import {Component, Input, OnInit} from '@angular/core';
import {FinantialProject} from '../../../../../class/lifeproject/finantial-project';

@Component({
    selector: 'app-finantial-view',
    templateUrl: './finantial-view.component.html',
    styleUrls: ['./finantial-view.component.css']
})
export class FinantialViewComponent implements OnInit {

    @Input()
    finantialProject: FinantialProject;

    constructor() {
    }

    ngOnInit() {
    }

}
